import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ResetAiChatConversationMutationVariables = Types.Exact<{ [key: string]: never }>

export type ResetAiChatConversationMutation = { resetAiChatConversation?: boolean | null }

export const ResetAiChatConversationDocument = gql`
  mutation resetAiChatConversation {
    resetAiChatConversation
  }
`
export type ResetAiChatConversationMutationFn = Apollo.MutationFunction<
  ResetAiChatConversationMutation,
  ResetAiChatConversationMutationVariables
>

/**
 * __useResetAiChatConversationMutation__
 *
 * To run a mutation, you first call `useResetAiChatConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAiChatConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAiChatConversationMutation, { data, loading, error }] = useResetAiChatConversationMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetAiChatConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetAiChatConversationMutation,
    ResetAiChatConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResetAiChatConversationMutation,
    ResetAiChatConversationMutationVariables
  >(ResetAiChatConversationDocument, options)
}
export type ResetAiChatConversationMutationHookResult = ReturnType<
  typeof useResetAiChatConversationMutation
>
export type ResetAiChatConversationMutationResult =
  Apollo.MutationResult<ResetAiChatConversationMutation>
export type ResetAiChatConversationMutationOptions = Apollo.BaseMutationOptions<
  ResetAiChatConversationMutation,
  ResetAiChatConversationMutationVariables
>
